import {
  type SerializedCompStructure,
  type SerializedPageStructure,
} from '@wix/document-services-types'

import { type ComponentConnection } from '../types'
import { assertConnectionList } from './assertConnectionList'
import { assertNonNullable } from './assertNonNullable'

export const getVeloIdOf = (
  componentOrPage: SerializedCompStructure | SerializedPageStructure,
): string => {
  if (!('connections' in componentOrPage)) {
    throw new Error('Missing connections.')
  }
  assertConnectionList(componentOrPage.connections)
  const connection = componentOrPage.connections.items.find(
    (
      connection,
    ): connection is Extract<
      ComponentConnection,
      { type: 'WixCodeConnectionItem' }
    > => connection.type === 'WixCodeConnectionItem',
  )
  assertNonNullable(connection)
  return connection.role
}
